'use no memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Card } from '@/components/Card/card';
import FormRootError from '@/components/Dialog/FormRootError';
import StepFooter from '@/components/Footer/StepFooter';
import { HStack, VStack } from '@/components/Layout';
import StepperNavigation from '@/components/Navigation/StepperNavigation';
import { Text } from '@/components/Typography/Text';
import useFormWithZod from '@/hooks/useFormWithZod';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { ItemIdentityFormFields, itemIdentityFormDefaultValues, itemIdentityFormSchema } from '../-components/ItemIdentityFormFields';
import { useCreateItem } from '../-queries/useCreateItem';
import { ItemAddProgressCard } from './-components/ItemAddProgressCard';
const IDENTITY_SECTION_HASH = 'identity';
export const Route = createFileRoute('/_staff/item-ledger/add/')({
  component: AddItemPage
});
function AddItemPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.itemLedger'
  });
  const navigate = useNavigate({
    from: '/item-ledger/add'
  });
  const createMutation = useCreateItem();
  const form = useFormWithZod({
    schema: itemIdentityFormSchema,
    defaultValues: itemIdentityFormDefaultValues
  });
  const handleSubmit = form.handleSubmit(async data => {
    try {
      const result = await createMutation.mutateAsync({
        name: data.name,
        itemTypeId: data.itemTypeId,
        baseUnit: data.baseUnit,
        description: data.description ?? null
      });
      await navigate({
        to: '/item-ledger/add/completed',
        search: {
          addedItemID: result.itemId
        }
      });
    } catch (error) {
      form.setError('root', {
        message: error instanceof Error ? error.message : 'Failed to create item'
      });
    }
  });
  const handleCancel = () => {
    void navigate({
      to: '/item-ledger'
    });
  };
  return <HStack className="w-full p-6 gap-6">
      <div className="shrink-0">
        <StepperNavigation link={{
        hash: IDENTITY_SECTION_HASH,
        to: '/item-ledger/add'
      }} sections={[{
        label: t('sectionIdentity'),
        hash: IDENTITY_SECTION_HASH,
        completed: false
      }]} />
      </div>

      <VStack className="gap-6 grow min-w-[340px]">
        <Card className="p-6">
          <Text variant="h3">{t('sectionIdentity')}</Text>
        </Card>
        <FormRootError form={form} />
        <Card className="p-6">
          <ItemIdentityFormFields control={form.control} />
        </Card>
        <StepFooter leftButton={{
        onClick: handleCancel
      }} rightButton={{
        onClick: handleSubmit,
        label: t('actionAdd'),
        isLoading: createMutation.isPending
      }} />
      </VStack>

      <div className="shrink-0">
        <ItemAddProgressCard control={form.control} />
      </div>
    </HStack>;
}